import { Component, EventEmitter, Output } from "@angular/core";
import { OrgSubscription } from "../../_models/common/OrgSubscription";
import { ApiRequest, IApiRequest } from "../../_models";
import { Guid } from "guid-typescript";
import { Claims } from "../../_models/common/claims";
import { ClaimsService } from "../../_services/common/claims.service";
import { OrganisationSubscriptionInvoiceService } from "../../_services/billing-pricing/Organisation-Subscription-Invoice.service";
import { first } from "rxjs";
import { OrganisationSubscriptionInvoiceResponse } from "../../_models/billing-pricing/OrganisationSubscriptionInvoice";
import { AuthenticationService } from "../../_services";
import { Router } from "@angular/router";
import { ExpenseExporService } from "../../_services/expenseExport/expense-expor.service";

@Component({
    selector: 'notification-unsubscribe-panel',
    templateUrl: './notification-unsubscribe-panel.html',
    standalone: false
})
export class NotificationUnsubscribePanel {
  @Output() closePanelEvent = new EventEmitter<boolean>();
  param: any;
  OrgInvoiceRequest: IApiRequest<OrgSubscription>;
  public UniqueId: Guid;
  claims: Claims;
  organisationSubscriptionInvoiceResponse: OrganisationSubscriptionInvoiceResponse[] = [];
  showPanel: boolean = true;

  constructor(
    private claimsService: ClaimsService,
    private organisationSubscriptionInvoiceService: OrganisationSubscriptionInvoiceService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private expenseExporService: ExpenseExporService,
  ) {
    this.UniqueId = Guid.create();
    this.claimsService.currentClaims.subscribe((claims) => {
      this.claims = claims;
    });
  }

  ngOnInit() {
    this.getOrgInvoice();
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(["login"]);
  }
  
  getOrgInvoice() {
      this.OrgInvoiceRequest = new ApiRequest<OrgSubscription>(
        "SoloOrganisationSubscriptionInvoice",
        0,
        this.UniqueId.toString()
      );
      this.OrgInvoiceRequest.requestInfo = new OrgSubscription(this.claims.OrgId);
      this.organisationSubscriptionInvoiceService
        .GetOrganisationSubscriptionInvoiceList(this.OrgInvoiceRequest).subscribe(
          (data) => {
            if (data.statusCode == 0) {
              this.organisationSubscriptionInvoiceResponse = data.responseInfo;
            } 
          }
        );
    }

    download(fileName: string) {
      window.open(fileName, "_blank");
    }

    ResubscribeEODApplication() {
      this.expenseExporService.ResubscribeEODApplication(this.claims.OrgId).subscribe((data) => {
          this.claims.HasTemporaryUnsubscribed = false;
          this.claimsService.updateClaims(this.claims);
          this.showPanel = false;
        });
        
      }
}